import { render, staticRenderFns } from "./NbQyJbxx.vue?vue&type=template&id=9b830f40&scoped=true"
import script from "./NbQyJbxx.vue?vue&type=script&lang=js"
export * from "./NbQyJbxx.vue?vue&type=script&lang=js"
import style0 from "./NbQyJbxx.vue?vue&type=style&index=0&id=9b830f40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b830f40",
  null
  
)

export default component.exports